// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as Slider_Lazy$Showside from "../utils/Slider_Lazy.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
function ListPageSlider(Props) {
  var id = Props.id;
  var rowsOpt = Props.rows;
  var children = Props.children;
  var shouldCenterOpt = Props.shouldCenter;
  var slidesPerView = Props.slidesPerView;
  var gapOpt = Props.gap;
  var effectOpt = Props.effect;
  var navOpt = Props.nav;
  var transitionOpt = Props.transition;
  var transitionSpeedOpt = Props.transitionSpeed;
  var autoplayOpt = Props.autoplay;
  var autoplayDelayOpt = Props.autoplayDelay;
  var loopOpt = Props.loop;
  var duplicateSlidesForLoopingAutoplayOpt = Props.duplicateSlidesForLoopingAutoplay;
  var padding = Props.padding;
  var verticalPaddingOpt = Props.verticalPadding;
  var maxWidth = Props.maxWidth;
  var firstSlide = Props.firstSlide;
  var lastSlide = Props.lastSlide;
  var enableScrollbarOpt = Props.enableScrollbar;
  var enableNavigationOpt = Props.enableNavigation;
  var enableDotsOpt = Props.enableDots;
  var onInit = Props.onInit;
  var className = Props.className;
  var rows = rowsOpt !== undefined ? rowsOpt : 1;
  var shouldCenter = shouldCenterOpt !== undefined ? shouldCenterOpt : false;
  var gap = gapOpt !== undefined ? gapOpt : /* Equal */0;
  var effect = effectOpt !== undefined ? effectOpt : /* EffectSlide */0;
  var nav = navOpt !== undefined ? navOpt : /* NavAuto */0;
  var transition = transitionOpt !== undefined ? transitionOpt : /* TransitionEase */0;
  var transitionSpeed = transitionSpeedOpt !== undefined ? transitionSpeedOpt : 300;
  var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
  var autoplayDelay = autoplayDelayOpt !== undefined ? autoplayDelayOpt : 3000;
  var loop = loopOpt !== undefined ? loopOpt : false;
  var duplicateSlidesForLoopingAutoplay = duplicateSlidesForLoopingAutoplayOpt !== undefined ? duplicateSlidesForLoopingAutoplayOpt : false;
  var verticalPadding = verticalPaddingOpt !== undefined ? verticalPaddingOpt : false;
  var enableScrollbar = enableScrollbarOpt !== undefined ? enableScrollbarOpt : true;
  var enableNavigation = enableNavigationOpt !== undefined ? enableNavigationOpt : true;
  var enableDots = enableDotsOpt !== undefined ? enableDotsOpt : true;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var enableScrollbar$1 = enableScrollbar && (nav === /* NavScrollbar */2 || nav === /* NavAuto */0 && !isMobile);
  var enableNavigation$1 = enableNavigation && (nav === /* NavArrows */1 || nav === /* NavAuto */0 && !isMobile);
  var enablePagination = enableDots && nav === /* NavDots */3;
  var swiperEffect = effect ? "fade" : undefined;
  var transition$1;
  switch (transition) {
    case /* TransitionEase */0:
      transition$1 = "ease";
      break;
    case /* TransitionLinear */1:
      transition$1 = "linear";
      break;
    case /* TransitionEaseIn */2:
      transition$1 = "ease-in";
      break;
    case /* TransitionEaseOut */3:
      transition$1 = "ease-out";
      break;
    case /* TransitionEaseInOut */4:
      transition$1 = "ease-in-out";
      break;
  }
  var ref = React.useRef(null);
  LCPContext$Showside.use(undefined);
  var rows$1 = Math.max(rows, 1);
  var needsMarginBottom = rows$1 > 1;
  var start = function (children) {
    return Belt_Array.concat(firstSlide !== undefined ? [Caml_option.valFromOption(firstSlide)] : [], children);
  };
  var end = function (children) {
    return Belt_Array.concat(children, lastSlide !== undefined ? [Caml_option.valFromOption(lastSlide)] : []);
  };
  var spaceBetweenCn;
  if (typeof gap === "number") {
    switch (gap) {
      case /* Equal */0:
        spaceBetweenCn = Cn.make(["mr-col-custom", needsMarginBottom ? "mb-col-custom" : ""]);
        break;
      case /* Half */1:
        spaceBetweenCn = Cn.make(["mr-col-custom-half", needsMarginBottom ? "mb-col-custom-half" : ""]);
        break;
      case /* Double */2:
        spaceBetweenCn = Cn.make(["mr-col-custom-double", needsMarginBottom ? "mb-col-custom-double" : ""]);
        break;
    }
  } else {
    spaceBetweenCn = "";
  }
  var marginRight = typeof gap === "number" ? undefined : CSS$Showside.intToPx(gap._0);
  var marginBottom = typeof gap === "number" || !needsMarginBottom ? undefined : CSS$Showside.intToPx(gap._0);
  var slidesPerGroup = Math.max((Math.floor(slidesPerView) | 0) - 1 | 0, 1);
  var sliderOffset = padding !== undefined ? padding : isMobile ? 12 : 24;
  var slides = React.useMemo(function () {
    return Belt_Array.mapWithIndex(end(start(children)), function (i, el) {
      var tmp = {};
      if (marginRight !== undefined) {
        tmp.marginRight = marginRight;
      }
      if (marginBottom !== undefined) {
        tmp.marginBottom = marginBottom;
      }
      var style = tmp;
      return React.createElement("div", {
        key: String(i),
        className: CSS$Showside.prefix(Cn.make(["flex flex-col", spaceBetweenCn])),
        style: style
      }, el);
    });
  }, [children]);
  var maxWidth$1 = maxWidth !== undefined ? CSS$Showside.intToPx(maxWidth) : undefined;
  var tmp = {
    marginRight: "auto",
    marginLeft: "auto"
  };
  if (maxWidth$1 !== undefined) {
    tmp.maxWidth = maxWidth$1;
  }
  var style = tmp;
  var tmp$1 = {
    items: slides,
    slidesOffsetBefore: sliderOffset,
    slidesOffsetAfter: sliderOffset,
    slidesPerView: /* Float */{
      _0: slidesPerView
    },
    slidesPerGroup: slidesPerGroup,
    slidesPerColumn: rows$1,
    enableFreeMode: slidesPerView !== 1.0 && effect !== /* EffectFade */1 && !loop,
    centeredSlides: loop && !autoplay,
    centeredSlidesBounds: loop && !autoplay,
    centerInsufficientSlides: shouldCenter,
    enableScrollbar: enableScrollbar$1,
    dragScrollbar: true,
    enableNavigation: enableNavigation$1,
    enablePagination: enablePagination,
    enableMousewheel: true,
    enableAutoplay: autoplay,
    loop: loop,
    duplicateSlidesForLoopingAutoplay: duplicateSlidesForLoopingAutoplay,
    loopedSlides: Math.floor(slidesPerView),
    className: enableScrollbar$1 && !isMobile ? CSS$Showside.prefix("pb-8") : "",
    restorationId: "quicknav-category-slider-" + id + "",
    autoplayDelay: autoplayDelay,
    transition: transition$1,
    transitionSpeed: transitionSpeed,
    dataTestId: "list-page-slider",
    dataId: id
  };
  if (swiperEffect !== undefined) {
    tmp$1.effect = Caml_option.valFromOption(swiperEffect);
  }
  if (onInit !== undefined) {
    tmp$1.onInit = Caml_option.valFromOption(onInit);
  }
  return React.createElement("div", {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: Cn.make([Belt_Option.getWithDefault(className, ""), verticalPadding ? CSS$Showside.prefix("py-row-custom") : "", CSS$Showside.prefix("w-full")])
  }, React.createElement("div", {
    className: Cn.make(["swiper-auto-hide", isMobile ? "" : "swiper-large-navigation"]),
    style: style
  }, React.createElement(Slider_Lazy$Showside.make, tmp$1)));
}
ListPageSlider.displayName = "ListPageSlider";
var make = React.memo(ListPageSlider);
export { make };
/* make Not a pure module */